import styles from './switch-comp.module.scss';

export type Props = {
  name: string;
  isChecked: boolean;
  onClick: () => void;
  onText: string;
  offText: string;
};

export const SwitchComp = ({
  name,
  isChecked,
  onClick,
  onText,
  offText,
}: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.switch} onClick={onClick}>
        <input checked={isChecked} name={name} type='checkbox' readOnly />
        <span className={styles.slider} />
      </div>
      <span className={styles.state}>{isChecked ? onText : offText}</span>
    </div>
  );
};
